import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStateService } from '../services/auth-state.service';
import { HTTP_HEADERS } from '../constants/api.constants';

/**
 * Authentication interceptor
 * Automatically attaches JWT token to outgoing HTTP requests
 * 
 * Register in app.config.ts:
 * ```
 * import { provideHttpClient, withInterceptors } from '@angular/common/http';
 * import { authInterceptor } from './core/interceptors/auth.interceptor';
 * 
 * providers: [
 *   provideHttpClient(withInterceptors([authInterceptor]))
 * ]
 * ```
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authState = inject(AuthStateService);

  // Skip authentication for login/signup endpoints
  // But ALLOW auth header for /auth/current-user and other protected auth endpoints
  const skipAuthUrls = ['/auth/login', '/auth/signup', '/auth/google', '/auth/reset-password', '/auth/verify-email'];
  const shouldSkipAuth = skipAuthUrls.some(url => req.url.includes(url));
  
  if (shouldSkipAuth) {
    return next(req);
  }

  // Get access token
  const token = authState.getAccessToken();

  // If no token, proceed without modification
  if (!token) {
    return next(req);
  }

  // Clone request and add authorization header
  const authReq = req.clone({
    setHeaders: {
      [HTTP_HEADERS.AUTHORIZATION]: `Bearer ${token}`,
    },
  });

  return next(authReq);
};


